import axios from 'axios'
import storage from '../utils/storage'
import store from '../store'

// 创建 axios 实例，baseURL 指向后端 API
const request = axios.create({
  baseURL: '/api/v3',
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器：自动附加 JWT Token
request.interceptors.request.use(
  config => {
    // 兼容旧 key：优先读 user_real，回退到 user
    let user = storage.get('user_real')
    if (!user || !user.token) {
      user = storage.get('user')
    }
    if (user && user.token) {
      config.headers['Authorization'] = `Bearer ${user.token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器：统一处理错误
request.interceptors.response.use(
  response => {
    const res = response.data
    // 后端统一返回格式：{ code, data, message }
    if (res.code !== 200) {
      // 业务错误，如 404、403 等
      console.warn('[API] 业务错误:', res.message || `code=${res.code}`)
      return Promise.reject(new Error(res.message || '请求失败'))
    }
    return res
  },
  error => {
    if (error.response) {
      // HTTP 错误，如 401、500
      const status = error.response.status
      if (status === 401 || status === 403) {
        // Token 失效或权限不足，清除登录态并跳转到登录页
        store.commit('LOGOUT')
        window.location.href = '/#/login'
      }
      console.error('[API] HTTP 错误:', status, error.response.data)
    } else {
      console.error('[API] 网络错误:', error.message)
    }
    return Promise.reject(error)
  }
)

export default request
